export { default } from './P3ImageWall';
